<template>
  <div>
    <div class="addAddress_box">
      <div class="addressAdd_mesg">
        <div class="addressAdd_text">收货人</div>
        <input class="addressAdd_input" v-model="name" placeholder="请输入收货人名字" />
      </div>
      <div class="addressAdd_mesg">
        <div class="addressAdd_text">手机号码</div>
        <input class="addressAdd_input" v-model="phone" placeholder="请输入收获电话号码" />
      </div>
      <div class="addressAdd_mesg">
        <div class="addressAdd_text">所在地区</div>
        <!-- <input class="addressAdd_input" v-model="addressProvince" placeholder="省"/>
				<input class="addressAdd_input" v-model="addressCity" placeholder="市" />
				<input class="addressAdd_input" v-model="addressArea"  placeholder="区"/> -->
        <div @click="toAddress" class="address">{{addressProvince}}-{{addressCity}}-{{addressArea}}</div>
        <!-- <mt-picker :slots="addressSlots" class="picker" @change="onAddressChange" :visible-item-count="5"></mt-picker>
				省市区:{{ addressProvince }} {{ addressCity }} -->
      </div>
      <div class="addressAdd_mesg">
        <div class="addressAdd_text">收货地址详细描述</div>
        <input class="addressAdd_input" placeholder="请输入描述" v-model="desc" />
      </div>
    </div>
    <div class="morenaddress">
      <!-- <input type="radio" class="addaddressradio" /> -->
      <img class="addressdefault" :src="addressdefault? '/static/youlegouchecked.png' : '/static/youlegoucheck.png'" @click="isdefault()" />
      <div class="morendizhi">设为默认地址</div>
    </div>
    <div class="addAddress_bottom" @click="addAddress()">新增</div>
    <v-distpicker type="mobile" @selected='selected' v-show="addInp" class="area1">
    </v-distpicker>
    <!-- <div class="mask" v-show="mask"></div> -->
  </div>
</template>

<script>
  import httper from '../../api/http';
  import VDistpicker from 'v-distpicker'
  import {
    Dialog
  } from 'vant';
  export default {
    components: {
      VDistpicker
    },
    data() {
      return {
        name: "",
        phone: "",
        desc: "",
        addressProvince: '省',
        addressCity: '市',
        addressArea: '区',
        addressStreet: '街道',
        addInp: false,
        mask: false,
        isbuy:false,
        addressdefault:false,
        buymesg:""
      }
    },
    created() {
      if(this.$route.query.isbuy){
        this.isbuy = true
      }
      if(this.$route.query.buymesg){
        this.buymesg = JSON.parse(this.$route.query.buymesg)
      }
    },
    mounted() {

    },
    methods: {
      toAddress() {
        this.mask = true;
        this.addInp = true;
      },
      //是否为默认地址
      isdefault(){
        this.addressdefault = !this.addressdefault
      },
      // 省市区三级联动
      selected(data) {
        this.mask = false;
        this.addInp = false;
        console.log("地址", data)
        this.addressProvince = data.province.value
        this.addressCity = data.city.value
        this.addressArea = data.area.value
        // this.city = data.province.value + ' ' + data.city.value +' ' + data.area.value
      },
      addAddress() {
        let requestData = {}
        if (!this.name) {
          this.$toast({
            message: "请输入收货人姓名"
          })
          return
        }
        if (!this.phone) {
          this.$toast({
            message: "请输入收货手机号码"
          })
          return
        }
        if (!this.addressProvince) {
          this.$toast({
            message: "请输入省"
          })
          return
        }
        if (!this.addressCity) {
          this.$toast({
            message: "请输入市"
          })
          return
        }
        if (!this.addressArea) {
          this.$toast({
            message: "请输入区"
          })
          return
        }
        if (!this.desc) {
          this.$toast({
            message: "请输入详细地址"
          })
          return
        }
        if(this.addressdefault){
          requestData.default = 1
        }else{
          requestData.default = 0
        }
        requestData.province = this.addressProvince
        requestData.city = this.addressCity
        requestData.district = this.addressArea
        requestData.address = this.desc
        requestData.addressee = this.name
        requestData.mobile = this.phone

        this.request("addAddress", requestData)

      },
      //调用接口
      request(type = '', requestData = {}) {
        let that = this
        switch (type) {
          // 获取地址列表
          case 'addAddress':
            httper.post('/user/add-address', requestData, res => {
              if (res.code == 0) {
                that.$toast({
                  message: '添加成功'
                })
                if(this.isbuy){
                  that.$router.push({
                    path: "/youlegouAddressList",
                    query:{
                      isbuy:this.isbuy,
                      buymesg: JSON.stringify(that.buymesg)
                    }
                  })
                }else{
                  that.$router.push({
                    path: "/youlegouAddressList"
                  })
                }

              } else {
                this.$toast({
                  message: res.message
                })
              }
            }, true)
            break
        }
      },


    }
    // watch: {
    // 	'addressXian': {
    // 		handler(val, oval) {
    // 			let street = this.xianObj[this.addressXian]
    // 			this.streetSlots[0].values = street
    // 		}
    // 	}
    // }
  }
</script>

<style  scoped="scoped">
  body {
    background-color: #F5F5F5;
  }

  .addAddress_box {
    width: 100%;
 /*   min-height: 400px; */
    padding: 20px;
    box-sizing: border-box;
    background-color: #fff;
    margin: 20px 0;
  }

  .addressAdd_mesg {
    width: 100%;
    height: 60px;
    padding: 20px 0;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #E5E5E5;
  }

  .addressAdd_text {
    font-size: 12px;
  }

  .addressAdd_input {
    font-size: 12px;
margin-right: 20px;
  }

  input {
    border: none;
    text-align: right;
  }

  input:-ms-input-placeholder {
    font-size: 12px;
    color: #BBBBBB;
    text-align: right;
  }

  .morenaddress {
    display: flex;
    margin-left: 20px;
    align-items: center;
  }

  .addaddressradio {
    margin-right: 5px;
  }

  .morendizhi {
    font-size: 12px;

  }

  .addAddress_bottom {
    width: calc(100% - 40px);
    margin: 20px;
    height: 38px;
    background: #FF7906;
    border-radius: 19px;
    font-size: 15px;
    color: #fff;
    position: absolute;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .area1 {
    width: 100%;
    height: 45%;
    position: fixed;
    left: 0;
    bottom: 0;
    overflow-y: scroll;
  }

  .distpicker-address-wrapper .address-header ul {
    position: fixed !important;
    left: 0 !important;
    top: 0 !important;
  }
  li{
   list-style: none;
   }
   .address{
     margin-right: 20px;
   }
   .addressdefault{
     width: 20px;
     height: 20px;
     margin-right: 5px;
   }
</style>



// WEBPACK FOOTER //
// src/pages/youlegou/youlegouAddAddress.vue